import React, {CSSProperties, forwardRef, HTMLAttributes} from 'react'

import {getSurfaceStyle, surfaceColors} from './styles.js'

interface PanelProps extends HTMLAttributes<HTMLDivElement> {
    /** A shadow and the neutral background instead of a border on white */
    shadow?: boolean
}

/** A full-width block with a border, or a shadow, around a part of a page. Rest props and the ref go to the <div>. */
const Panel = forwardRef<HTMLDivElement, PanelProps>(function Panel({style, shadow, children, ...rest}, ref) {
    const panelStyle: CSSProperties = {
        background: shadow ? surfaceColors.panelShadowBackground : surfaceColors.background,
        width: '100%',
        ...getSurfaceStyle({shadow}),
        flexShrink: 0,
        ...style
    }

    return (
        <div {...rest} style={panelStyle} ref={ref}>
            {children}
        </div>
    )
})

export default Panel
